const Spinner: React.FC = () => {
  return (
    <div className="flex justify-center items-center h-screen z-50">
      <div className="w-8 h-8 border-4 border-blue-500 border-dotted rounded-full animate-spin"></div>
    </div>
  );
};

export default Spinner;
